import { GenPartial } from 'typeormgen';
import CmEpisodicCharacterNote from './cm-episodic-characters/cm-episodic-character.entity';
import HaEpisodicCharacterNote from './ha-episodic-characters/ha-episodic-character.entity';
import MuEpisodicCharacterNote from './mu-episodic-characters/mu-episodic-character.entity';
import PrEpisodicCharacterNote from './pr-episodic-characters/pr-episodic-character.entity';
import { SosCreateResponse, SosUpdateResponse } from './sos-response';
import { AnyEpisodicCharacterNote } from './types';

export interface EpisodicCharacterDeptartmentNotePayload {
	[departmentId: number]: GenPartial<AnyEpisodicCharacterNote>;
}

export interface EpisodicCharacterDepartmentNoteCreateResponse
	extends SosCreateResponse {
	created: {
		CmEpisodicCharacterNote: CmEpisodicCharacterNote[];
		HaEpisodicCharacterNote: HaEpisodicCharacterNote[];
		MuEpisodicCharacterNote: MuEpisodicCharacterNote[];
		PrEpisodicCharacterNote: PrEpisodicCharacterNote[];
	};
}

export interface EpisodicCharacterDepartmentNoteUpdateResponse
	extends SosUpdateResponse {
	updated: {
		CmEpisodicCharacterNote: CmEpisodicCharacterNote[];
		HaEpisodicCharacterNote: HaEpisodicCharacterNote[];
		MuEpisodicCharacterNote: MuEpisodicCharacterNote[];
		PrEpisodicCharacterNote: PrEpisodicCharacterNote[];
	};
}
